import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import applicantActionsSlice from 'store/slices/employer/applicants/applicant-actions-slice';
import applicantCommentsSlice from 'store/slices/employer/applicants/applicant-comments-slice';
import applicantsListActionsSlice from 'store/slices/employer/applicants/applicants-list-actions-slice';
import applicantsListSlice from 'store/slices/employer/applicants/applicants-list-slice';
import incompleteApplicantsSlice from 'store/slices/employer/applicants/incomplete-applicants-slice';
import createJobDetailsSlice from 'store/slices/employer/create-job/create-job-details-slice';
import createJobPaymentsSlice from 'store/slices/employer/create-job/create-job-payments-slice';
import createJobPreviewSlice from 'store/slices/employer/create-job/create-job-preview-slice';
import createJobSharedSlice from 'store/slices/employer/create-job/create-job-shared-slices';
import jobTitleSlice from 'store/slices/employer/create-job/job-title-slice';
import interviewsActionsSlice from 'store/slices/employer/interviews/interviews-actions-slice';
import interviewsDetailsSlice from 'store/slices/employer/interviews/interviews-details-slice';
import interviewsListSlice from 'store/slices/employer/interviews/interviews-list-slice';
import interviewsSharedSlice from 'store/slices/employer/interviews/interviews-shared-slice';
import jobInfoSlice from 'store/slices/employer/jobs/job-info-slice';
import jobsListActionsSlice from 'store/slices/employer/jobs/jobs-list-actions-slice';
import jobsListSlice from 'store/slices/employer/jobs/jobs-list-slice';
import resumeSlice from 'store/slices/employer/resume/resume-slice';
import accInfoSlice from "store/slices/employer/settingsTs/acc-info-slice";
import accessLevelsSlice from "store/slices/employer/settingsTs/access-levels";
import companyInfoSlice from "store/slices/employer/settingsTs/company-info-slice";
import securitySlice from "store/slices/employer/settingsTs/security-slice";
import creditSlice from "../admin/employer/credits-slice";
import empAccountsSlice from "../admin/employer/emp-accounts-slice";
import empDetailsSlice from "../admin/employer/emp-details-slice";
import productsSlice from "../admin/employer/products-slice";
import subsSlice from "../admin/employer/subs-slice";
import employerSignUpSlice from '../auth-v2/employer-sign-up-slice';
import employerSubDomainSlice from './employer-sub-domain/employer-sub-domain-slice';
import employerDetailsSlice from './employer/employer-details-slice';

const createJobPersistConfig = {
    key: 'createJob',
    storage,
    whitelist: ['companyInfo', 'jobDetails', 'jobTitleInfo',
        'isDetailsEnabled', 'isPreviewEnabled', 'isBundlesEnabled', 'isPaymentEnabled']
};

const paymentPersistConfig = {
    key: 'createJobPayment',
    storage,
    whitelist: ['selectedBundles', 'allBundles', 'orderId', 'totalJobCost']
};

const employerReducer = combineReducers({
    employer: empDetailsSlice.reducer,
    employerAccounts: empAccountsSlice.reducer,
    credits: creditSlice.reducer,
    subs: subsSlice.reducer,
    products: productsSlice.reducer,
    applicantsList: applicantsListSlice.reducer,
    applicantsListActions: applicantsListActionsSlice.reducer,
    jobTitle: jobTitleSlice.reducer,
    createJobShared: persistReducer(createJobPersistConfig, createJobSharedSlice.reducer),
    createJobDetails: createJobDetailsSlice.reducer,
    createJobPreview: createJobPreviewSlice.reducer,
    jobsListActions: jobsListActionsSlice.reducer,
    applicantComments: applicantCommentsSlice.reducer,
    createJobPayments: persistReducer(paymentPersistConfig, createJobPaymentsSlice.reducer),
    interviewsList: interviewsListSlice.reducer,
    interviewsDetails: interviewsDetailsSlice.reducer,
    interviewsActions: interviewsActionsSlice.reducer,
    applicantActions: applicantActionsSlice.reducer,
    incompleteApplicants: incompleteApplicantsSlice.reducer,
    interviewsShared: interviewsSharedSlice.reducer,
    jobInfo: jobInfoSlice.reducer,
    resume: resumeSlice.reducer,
    employerSubDomain: employerSubDomainSlice.reducer,
    jobsList: jobsListSlice.reducer,
    accInfo: accInfoSlice.reducer,
    companyInfo: companyInfoSlice.reducer,
    accessLevels: accessLevelsSlice.reducer,
    security: securitySlice.reducer,
    employerSignUp: employerSignUpSlice.reducer,
    employerDetails: employerDetailsSlice.reducer
});
export default employerReducer;
